<script>
  import Paper, { Title, Content } from '@smui/paper';
  import ShareButton from '$lib/client/shared/share-button.svelte';
  import Button, { Icon, Label } from '@smui/button';
  import { createEventDispatcher } from 'svelte';
  export let ask;
  let open = false;

const track = ask.context;
  const dispatch = createEventDispatcher();
</script>

<Title>{ ask.title || `${track.artist.name} are asking you to share ${track.title} with your friends` }</Title>
<Content>
  <slot>
      {ask.content}
  </slot>
  <nav class="actions b--secondary b--solid-t-tiny u-mt u-pt">
    <ShareButton {track} bind:open on:shared={(e) => dispatch('completed')}>
      <Button variant="raised" color="primary" on:click={() => (open = true)}
        ><Label>Share</Label> <Icon class="material-icons">share</Icon>
      </Button></ShareButton
               >
    <slot name="actions" />

  </nav>
</Content>
